module.exports = __webpack_public_path__ + "media/images/icons/flags/SS-4b4f02704f5eddf0445363a94ce8159d.svg";